import React, { useRef, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { FiBell } from "react-icons/fi";
import { useNotifications } from "../../hooks/useNotifications";
import NotificationPanel from "./NotificationPanel";
import styles from "./NotificationBell.module.css";

const NotificationBell = () => {
    const { unreadCount, isOpen, togglePanel, closePanel } = useNotifications();
    const wrapperRef = useRef(null);

    // Zamknij panel po kliknięciu poza nim
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                closePanel();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [closePanel]);

    return (
        <div className={styles.wrapper} ref={wrapperRef}>
            <button
                className={`${styles.bellBtn} ${isOpen ? styles.bellBtnActive : ""}`}
                onClick={togglePanel}
                title="Powiadomienia"
            >
                <FiBell size={18} />
                {unreadCount > 0 && (
                    <span className={styles.badge}>
                        {unreadCount > 99 ? "99+" : unreadCount}
                    </span>
                )}
            </button>

            <AnimatePresence>
                {isOpen && <NotificationPanel />}
            </AnimatePresence>
        </div>
    );
};

export default NotificationBell;
